import axiosHelper from '@/helpers/axiosHelper';
import { ClientChatProps } from '@/interfaces/models/clientChat';
import ClientChat from '@/models/clientChat';

export default axiosHelper.mergeAxiosResponseTransformerWithDefaults(
  (chat: ClientChatProps): any => new ClientChat(chat)
);
